import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data";

const SPECS = [
  { k: "Bosch", v: "ECU Diagnostics" },
  { k: "Hunter", v: "3D Wheel Alignment" },
  { k: "GYS", v: "Inverter Welding" },
  { k: "Kärcher", v: "Touchless Wash" },
];

export const Equipment = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="equipment"
      data-testid="equipment"
      className="relative overflow-hidden border-y border-white/10 bg-[#0a0a0a]"
    >
      <div className="mx-auto grid max-w-[1500px] grid-cols-1 lg:grid-cols-2">
        {/* Image side with parallax */}
        <div className="relative h-[60vh] overflow-hidden lg:h-auto">
          <motion.img
            style={{ y }}
            src={IMAGES.equipment}
            alt="German auto equipment in use"
            className="absolute inset-0 h-[124%] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0a0a0a]/50" />
          <div className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-[0.3em] text-white/70">
            / imported · calibrated · logged
          </div>
        </div>

        {/* Text side */}
        <div className="flex flex-col justify-center px-6 py-20 md:px-14 md:py-28">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--volt)]">
            / The Hardware
          </span>
          <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-white md:text-5xl">
            Machines that
            <br />
            don&apos;t compromise.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
            We import the same equipment used in European workshops and
            calibrate it to factory tolerances. No hand-me-down tools, no
            approximations — just measurable precision.
          </p>

          <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-white/10 bg-white/10">
            {SPECS.map((s, i) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="bg-[#0a0a0a] p-6"
              >
                <div className="font-display text-xl font-black text-white">
                  {s.k}
                </div>
                <div className="mt-1 font-mono text-[11px] uppercase tracking-wider text-white/50">
                  {s.v}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
